var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./KnowledgeDetails.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-6b39a87a!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./KnowledgeDetails.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Home/Knowledge/KnowledgeDetails.vue
// module id = 592
// module chunks = 0